import React from "react";
import {
    VerticalTimeline,
    VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import timelineData from "../../data/timeline.json";
import '../../styles/Adn.css';

const Evolution = () => {
    return (
        <section className="evolution-section">
            <div className="container">
                <div class="title-container" data-aos="fade-up">
                    <h2 class="title">Nuestra Evolución</h2>
                    <div class="title-underline"></div>
                </div>

                <div data-aos="fade-up">
                    <VerticalTimeline lineColor="#007b5e"> {/* Cambia el color de la línea central aquí */}
                        {timelineData.map((item, index) => (
                            <VerticalTimelineElement
                                key={index}
                                className="vertical-timeline-element--work"
                                contentStyle={{
                                    background: item.color,
                                    color: "#fff",
                                    borderRadius: "8px",
                                }}
                                contentArrowStyle={{ borderRight: `7px solid ${item.color}` }}
                                date={item.year}
                                dateClassName={`year-text-${index}`} // Clase CSS personalizada para el año
                                iconStyle={{
                                    background: item.color,
                                    color: "#fff",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                                icon={
                                    <img
                                        src={item.icon}
                                        alt={item.title}
                                        style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                    />
                                }
                            >
                                <h3 className="vertical-timeline-element-title">{item.title}</h3>
                                <p>{item.text}</p>
                            </VerticalTimelineElement>
                        ))}
                    </VerticalTimeline>
                </div>
            </div>
        </section>
    );
};

export default Evolution;





